module.exports = __webpack_public_path__ + "static/media/slms.6a780df6.png";